<!-- svelte-ignore a11y-missing-attribute -->

<div class="box">

    <!-- Main container -->
    <div class="level">
    <!-- Left side -->
    <div class="level-left">
    </div>
    <!-- Right side -->
    <div class="level-right">
      <div class="field is-horizontal">
        <div class="control">
            <input id="active" bind:checked={isOfferActive} type="checkbox" class="switch is-rtl is-success" on:change={() => {togglePause()}}>
            <label for="active">
              {#if isOfferActive}
              Accepting new requests
              {:else}
              New requests paused
              {/if}
            </label>
        </div>
      </div>
    </div>
  </div>

    {#if requests}
      {#if requests.length == 0 && data.status !== 'ended'}
        <article class="message is-info">
          <div class="message-body">
            Waiting for charities to request this offer. We'll notify you as soon
            as a request is made.
          </div>
        </article>
      {:else}
        {#if newRequests.length == 1 && selectedRequests.length == 0 && newRequests[0].data.status === 'interested'}
          <article class="message is-info">
            <div class="message-body">
              You've had an expression of interest! Answer any questions via the chat functionality
            </div>
          </article>
        {:else if selectedRequests.length == 0 && newRequests.filter((request) => request.data.status === 'interested').length > 1}
          <article class="message is-info">
            <div class="message-body">
              You've had multiple expressions of interest! Answer any questions via the chat functionality
            </div>
          </article>
        {:else if newRequests.length == 1 && selectedRequests.length == 0}
          <article class="message is-info">
            <div class="message-body">
              You've had a request! You can select this request or wait for more.
            </div>
          </article>
        {:else if newRequests.length > 1 && selectedRequests.length == 0}
          <article class="message is-info">
            <div class="message-body">
              You've had multiple requests! You can select a request or wait for more.
            </div>
          </article>
        {:else if selectedRequests.length > 0}
          <article class="message is-info">
            <div class="message-body">
              View your {selectedRequests.length == 1 ? 'match' : 'matches'} <a href="matches">here</a>.
            </div>
          </article>
        {/if}
      {/if}
    {/if}

<table class="table is-fullwidth is-hoverable">
  <tbody>
    {#if unselectedRequests}
      {#each unselectedRequests as request}
        <tr>
          <td>
            <div class="mb-1">
              <a href={$url('../../../request/' + request.id)}>{request.data.charity.name}</a>
              &nbsp;
              {#if request.data.charity.highlight}
              <HighlightedTag highlight={request.data.charity.highlight} />
              {/if}
            </div>
            
            {#if request.data.message && !isChatEnabled}
            <div>
              <Message
                >{request.data.message.substring(0, 100)}
                {#if request.data.message.length > 100}...{/if}</Message
              >
            </div>
            {/if}
            {#if isChatEnabled}
              <!-- {#each unreadMessages as unreadMessage} -->
                {#if noOfUnreadMessages(unreadMessages, request) > 0}
                  <NewMessageIcon />
                  <span class="tag is-primary is-light is-medium">
                    You have {noOfUnreadMessages(unreadMessages, request)} new message{noOfUnreadMessages(unreadMessages, request) > 1 ? 's' : ''}
                  </span>
                {/if}
              <!-- {/each} -->
            {/if}
            
          </td>
          <td>
            <span style="white-space:nowrap;" class="has-text-grey-light">
              {$appState.company
                ? distance(request.data.charity.location, $appState.company.location)
                : 'nearby'}
            </span>
          </td>
          <td>
            {#if request.data.created}
              <span style="white-space:nowrap;" class="has-text-grey-light">
                {dayjs().to(dayjs(request.data.created))}
              </span>
            {/if}
          </td>
          <td>
            <RequestStatusTag status={request.data.status || 'new'} />
          </td>
        </tr>
      {/each}
    {/if}
  </tbody>
</table>

</div>

<script lang="ts">
  export let scoped : { id: OfferId, data: Offer_v2, requests: Request_v2_Doc[], unreadMessages: UnreadMessage[] };
    
  import _ from 'lodash';
  import { appState } from '../../../../lib/appState';
  import { url } from '@sveltech/routify';
  import RequestStatusTag from '../../../_components/RequestStatusTag.svelte';
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';
  dayjs.extend(relativeTime);

  import HighlightedTag from '../../_components/HighlightedTag.svelte';
  import Message from '../../../_components/Message.svelte';
  import NewMessageIcon from '../../../_components/NewMessageIcon.svelte';
  import geoDist from 'geo-dist';
  import getFeatureFlags from '../../../../utils/getFeatureFlags';

  const { isChatEnabled } = getFeatureFlags();

  const firebase = window.firebase;

  $: data = scoped.data;
  $: requests = scoped.requests;
  $: unreadMessages = _.uniq(scoped.unreadMessages);

  $: selectedRequests = requests.filter(req =>
    req.data.status == 'selected' || 
    req.data.status == 'matched' || 
    req.data.status == 'completed' || 
    req.data.status == 'failed' );

  $: unselectedRequests = requests
  .filter(req =>
    req.data.status === 'new' || 
    req.data.status === 'unsuccessful' || 
    req.data.status == 'withdrawn' || 
    req.data.status === 'interested')
  .sort((a,b) => {
    return a.data.charity.highlight ? -1 : 1;
  });

  $: newRequests = requests.filter(req =>
    req.data.status === 'new' || 
    req.data.status === 'interested');

  $: isOfferActive = !data.paused; 

  function noOfUnreadMessages(messages: UnreadMessage[], request: Request_v2_Doc ) {
    let count = 0
    messages.forEach(unreadMessage => {
      if (unreadMessage.requestId == request.id) {
        count += 1
      }
    })
    return count;
  }

  function togglePause() {
    firebase.functions().httpsCallable('api-offer-pauseoffer')({
      id: scoped.id,
      paused: !data.paused
    });

    data.paused = !data.paused;
  }

  function distance(point1: GeoPoint, point2: GeoPoint) {
    const km = geoDist(
      point1.latitude,
      point1.longitude,
      point2.latitude,
      point2.longitude
    );
    const miles = km * 0.6213712; // miles
    if (miles < 1) {
      return 'Within 1 mile';
    } else if (miles < 4.5) {
      return miles.toFixed(1) + ' miles away';
    } else {
      return Math.round(miles) + ' miles away';
    }
  }
</script>
